export default {
  name: "AdManagerOverview",
  data: () => ({}),
  async mounted() {
    if (!this.isAdManagerUser) {
      return await this.$router.push(`/admanager/`);
    }
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isAdManagerAdmin() {
      return (
        this.isAdmin ||
        this.currentUser?.scopes?.includes("role:admanager_admin")
      );
    },
    isAdManagerUser() {
      return (
        this.isAdManagerAdmin ||
        this.currentUser?.scopes?.includes("role:admanager")
      );
    }
  }
};
